import { render, staticRenderFns } from "./WebAddressEdit.vue?vue&type=template&id=37bd24cb&scoped=true"
import script from "./WebAddressEdit.vue?vue&type=script&lang=js"
export * from "./WebAddressEdit.vue?vue&type=script&lang=js"
import style0 from "./WebAddressEdit.vue?vue&type=style&index=0&id=37bd24cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd24cb",
  null
  
)

export default component.exports